<!-- 资产流程表格 -->
<template>
  <div class="content" style="width: 100%; height: 100%">
    <div class="table-info">
      <el-table
        v-loading="is_loading"
        key="tableKey"
        ref="tableData"
        :data="pageData"
        tooltip-effect="dark"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        @selection-change="onSelect"
      >
        <template v-for="col in Columns">
          <!-- 选择框 -->
          <template v-if="col.type === 'select'">
            <el-table-column
              type="selection"
              :key="col.prop"
              :prop="col.prop"
              :label="col.label"
              :min-width="col.minWidth"
              width="50"
              :fixed="col.fixed"
              :align="col.align || 'center'"
            ></el-table-column>
          </template>
          <template v-else-if="col.type === 'index'">
            <el-table-column
              type="index"
              :key="col.prop"
              :prop="col.prop"
              :label="col.label"
              :min-width="col.minWidth"
              width="60"
              :fixed="col.fixed"
              :align="col.align || 'center'"
            ></el-table-column>
          </template>
          <template v-else>
            <el-table-column
              :key="col.prop"
              :prop="col.prop"
              :label="col.label"
              :min-width="col.minWidth"
              :width="col.width"
              :show-overflow-tooltip="true"
              :fixed="col.fixed"
              :align="col.align || 'center'"
            >
            </el-table-column
          ></template>
        </template>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.length"
        :current-page="pageInfo.currentPage"
        :page-sizes="pageInfo.pageSize"
        :page-size="pageInfo.size"
        @size-change="changeSize"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  storageByBoxColumns,
  exportByBoxColumns,
  facilityAssetsIntoStorageColumns,
  facilityAssetsOutOfStorageColumns,
  facilitiesWarehousingApprovalColumns,
  facilitiesOutOfTheWarehouseApprovalColumns,
  networkAssetRemovalColumns,
  server_non_standard_Columns,
} from './config';
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    context: {
      type: Object,
      default: () => ({}),
    },
    toggle: {
      type: Boolean,
      default: false,
    },
    is_loading: {
      type: Boolean,
      default: false,
    },
    columnsType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tableData: [],
      pageData: [],
      pageInfo: {
        currentPage: 1,
        pageSize: [10, 20, 30, 50, 100],
        size: 100,
      },
      Columns: [],
      storageByBoxColumns,
      exportByBoxColumns,
      facilityAssetsIntoStorageColumns,
      facilitiesWarehousingApprovalColumns,
      facilityAssetsOutOfStorageColumns,
      facilitiesOutOfTheWarehouseApprovalColumns,
      networkAssetRemovalColumns,
      server_non_standard_Columns,
    };
  },

  watch: {
    value: {
      handler(val) {
        this.$nextTick(() => {
          this.tableData = [...val];
          this.changePage(this.pageInfo.currentPage);
        });
      },
      deep: true,
    },
    toggle: {
      handler() {
        this.$nextTick(() => {
          this.$refs.tableData.doLayout();
          this.tableData = [...this.tableData];
          this.changePage(this.pageInfo.currentPage);
        });
      },
      deep: true,
      immediate: false,
    },
  },
  mounted() {
    this.setColumns();
    this.$emit('selection-change', this.tableData);
  },
  methods: {
    /*
   columnsType:1 网络按箱入库流程
   columnsType:2 网络按箱出库流程
   columnsType:3 设施入库流程-责任人
   columnsType:4 设施入库流程-数经
   columnsType:5 设施入库流程-备品备件
   columnsType:6 设施入库库流程-工具
   columnsType:7 设施出库流程-责任人
   columnsType:8 设施出库流程-数经
   columnsType:9 设施出库流程-备品备件
   columnsType:10 设施出库流程-工具
   columnsType:11 网络资产挪库
   columnsType:12 服务器非标
   */
    setColumns() {
      try {
        switch (this.columnsType) {
          case 1:
            this.Columns = this.storageByBoxColumns;
            break;
          case 2:
            this.Columns = this.exportByBoxColumns;
            break;
          case 3:
            this.Columns = this.facilitiesWarehousingApprovalColumns.filter(
              (v) => v.label != '逻辑库'
            );
            break;
          case 4:
            this.Columns = this.facilitiesWarehousingApprovalColumns;
            break;
          case 5:
            this.Columns = this.facilityAssetsIntoStorageColumns;
            break;
          case 6:
            // 设施入库-工具没有逻辑库字段
            this.Columns = this.facilityAssetsIntoStorageColumns.filter((v) => v.label != '逻辑库');
            break;
          case 7:
            this.Columns = this.facilitiesOutOfTheWarehouseApprovalColumns.filter(
              (v) => v.label != '逻辑库'
            );
            break;
          case 8:
            this.Columns = this.facilitiesOutOfTheWarehouseApprovalColumns;
            break;
          case 9:
            this.Columns = this.facilityAssetsOutOfStorageColumns.filter(
              (v) => v.label != '存放房间'
            );
            break;
          case 10:
            this.Columns = this.facilityAssetsOutOfStorageColumns.filter(
              (v) =>
                v.label != '逻辑库' &&
                v.label != '资产库' &&
                v.label != '资产架' &&
                v.label != '资产位'
            );
            break;
          case 11:
            this.Columns = this.networkAssetRemovalColumns;
            break;
          case 12:
            this.Columns = this.server_non_standard_Columns;
            break;
          default:
            this.Columns = [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    onSelect(val) {
      this.$emit('selection-change', val);
    },
    changePage(page) {
      this.pageInfo.currentPage = page;
      const startIndex = (this.pageInfo.currentPage - 1) * this.pageInfo.size;
      const endIndex = startIndex + this.pageInfo.size;
      this.pageData = this.tableData.slice(startIndex, endIndex);
    },
    changeSize(size) {
      this.pageInfo.size = size;
      this.changePage(1);
    },
  },
};
</script>

<style scoped lang="less">
.content {
  .table-info {
    width: 100%;
    overflow-x: auto;
  }
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
